export { default } from './ResourcesInternalFolder';
